(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ln-delivery-zone"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ln-delivery-zone')) {
    class LNDeliveryZone extends HTMLElement {
      static selected;
      static storageKey = 'ln_delivery_destination_v1';
      static choices = ['', 'rosario', 'funes', 'roldan', 'other'];

      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        const { signal } = this.controller;

        if (LNDeliveryZone.selected === undefined) {
          let saved = '';
          try { saved = localStorage.getItem(LNDeliveryZone.storageKey) || ''; } catch {}
          LNDeliveryZone.selected = LNDeliveryZone.choices.includes(saved) ? saved : '';
        }

        this.showDestination(LNDeliveryZone.selected);
        // Delegate to the component because cart rendering can replace the select.
        this.addEventListener('change', (event) => {
          if (!(event.target instanceof HTMLSelectElement) || !event.target.matches('[data-delivery-select]')) return;
          const zone = event.target.value;
          if (!LNDeliveryZone.choices.includes(zone)) return;
          LNDeliveryZone.selected = zone;
          try {
            if (zone) localStorage.setItem(LNDeliveryZone.storageKey, zone);
            else localStorage.removeItem(LNDeliveryZone.storageKey);
          } catch {}
          document.dispatchEvent(new CustomEvent('ln:delivery-zone', { detail: { zone } }));
        }, { signal });

        document.addEventListener('ln:delivery-zone', (event) => {
          if (LNDeliveryZone.choices.includes(event.detail?.zone)) this.showDestination(event.detail.zone);
        }, { signal });

        // Horizon morphs the cart's children without reconnecting this element.
        // Restore local state after that update, including when children arrive later.
        this.observer = new MutationObserver(() => this.showDestination(LNDeliveryZone.selected));
        this.observer.observe(this, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['disabled', 'hidden', 'selected'],
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }

      showDestination(zone) {
        const select = this.querySelector('[data-delivery-select]');
        if (!select) return;
        if (select.disabled) select.disabled = false;
        if (select.value !== zone) select.value = zone;
        const hint = this.querySelector('[data-delivery-empty]');
        if (hint && hint.hidden !== Boolean(zone)) hint.hidden = Boolean(zone);
        this.querySelectorAll('[data-delivery-zone]').forEach((panel) => {
          const hidden = panel.dataset.deliveryZone !== zone;
          if (panel.hidden !== hidden) panel.hidden = hidden;
        });
      }
    }
    customElements.define('ln-delivery-zone', LNDeliveryZone);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ln-factory-film"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ln-factory-film')) {
    class LnFactoryFilm extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        if (!this.video || !this.button) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.dataPreference = matchMedia('(prefers-reduced-data: reduce)');
        this.connection = navigator.connection;
        this.inView = false;
        this.pageReady = false;
        this.loaded = false;
        this.failed = false;
        this.playPending = false;
        this.motionSeconds = 0;
        this.lastMediaTime = 0;
        this.restRemaining = 0;
        try { this.manualPause = sessionStorage.getItem('ln_factory_paused') === 'true'; } catch { this.manualPause = false; }
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.playsInline = true;
        const sync = () => this.sync();
        document.addEventListener('visibilitychange', sync, { signal });
        this.motion.addEventListener('change', sync, { signal });
        this.dataPreference.addEventListener('change', sync, { signal });
        this.connection?.addEventListener('change', sync, { signal });
        this.dialogObserver = new MutationObserver(sync);
        this.dialogObserver.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries.some(entry => entry.isIntersecting);
          this.sync();
        });
        this.observer.observe(this.closest('.ln-catalog-scene'));
        this.button.addEventListener('click', () => {
          this.manualPause = !this.manualPause;
          try { sessionStorage.setItem('ln_factory_paused', String(this.manualPause)); } catch {}
          this.updateButton();
          this.sync();
        }, { signal });
        this.video.addEventListener('playing', () => {
          clearTimeout(this.watchdog);
          if (!this.canRun()) { this.video.pause(); return; }
          this.setAttribute('data-ready', '');
          this.updateButton();
        }, { signal });
        this.video.addEventListener('waiting', () => {
          clearTimeout(this.watchdog);
          if (this.canRun()) this.watchdog = setTimeout(() => this.disable(), 4000);
        }, { signal });
        this.video.addEventListener('error', () => this.disable(), { signal });
        this.video.addEventListener('timeupdate', () => {
          const now = this.video.currentTime;
          let delta = now - this.lastMediaTime;
          if (delta < 0 && Number.isFinite(this.video.duration)) delta += this.video.duration;
          this.lastMediaTime = now;
          if (this.video.paused || !this.canRun()) return;
          if (delta > 0 && delta < 1) this.motionSeconds += delta;
          if (this.motionSeconds >= 6) {
            this.motionSeconds = 0;
            this.restRemaining = 2000;
            this.sync();
          }
        }, { signal });
        const afterLoad = () => {
          this.loadDelay = setTimeout(() => {
            const start = () => { this.pageReady = true; this.sync(); };
            if ('requestIdleCallback' in window) this.idle = requestIdleCallback(start, { timeout: 2000 });
            else start();
          }, 500);
        };
        if (document.readyState === 'complete') afterLoad();
        else window.addEventListener('load', afterLoad, { once: true, signal });
        this.updateButton();
      }
      eligible() {
        const c = this.connection;
        return !this.motion.matches && !this.dataPreference.matches && !c?.saveData &&
          !['slow-2g', '2g', '3g'].includes(c?.effectiveType) &&
          !(c?.downlink > 0 && c.downlink < 2) && !(c?.rtt > 400) &&
          !(navigator.deviceMemory > 0 && navigator.deviceMemory <= 2) &&
          !(navigator.hardwareConcurrency > 0 && navigator.hardwareConcurrency <= 2);
      }
      canRun() {
        return this.isConnected && !this.failed && this.eligible() && this.pageReady &&
          this.inView && !document.hidden && !this.manualPause && !document.querySelector('dialog[open]');
      }
      updateButton() {
        this.button.textContent = this.manualPause ? this.dataset.playLabel : this.dataset.pauseLabel;
        this.button.setAttribute('aria-pressed', String(this.manualPause));
        this.button.hidden = (!this.hasAttribute('data-ready') && !this.manualPause) || this.failed || !this.eligible();
      }
      stopRest() {
        if (!this.restTimer) return;
        clearTimeout(this.restTimer);
        this.restRemaining = Math.max(0, this.restRemaining - (performance.now() - this.restStarted));
        this.restTimer = null;
      }
      sync() {
        if (!this.abort) return;
        if (!this.eligible() || this.failed) {
          this.stopRest();
          clearTimeout(this.watchdog);
          this.video.pause();
          this.removeAttribute('data-ready');
          if (this.loaded) {
            this.video.removeAttribute('src');
            this.video.load();
            this.loaded = false;
            this.lastMediaTime = 0;
            this.motionSeconds = 0;
          }
          this.updateButton();
          return;
        }
        this.updateButton();
        if (!this.canRun()) {
          this.stopRest();
          clearTimeout(this.watchdog);
          this.video.pause();
          return;
        }
        if (!this.loaded) {
          this.loaded = true;
          this.video.src = matchMedia('(max-width: 749px)').matches ? this.dataset.mobileSrc : this.dataset.desktopSrc;
          this.video.load();
          this.watchdog = setTimeout(() => this.disable(), 8000);
        }
        if (this.restRemaining > 0) {
          this.video.pause();
          if (!this.restTimer) {
            this.restStarted = performance.now();
            this.restTimer = setTimeout(() => {
              this.restRemaining = 0;
              this.restTimer = null;
              this.sync();
            }, this.restRemaining);
          }
          return;
        }
        if (this.video.paused && !this.playPending) {
          this.playPending = true;
          this.video.play().then(() => {
            this.playPending = false;
            if (!this.canRun()) this.video.pause();
          }).catch(error => {
            this.playPending = false;
            if (error.name !== 'AbortError' && this.isConnected) this.disable();
          });
        }
      }
      disable() {
        this.failed = true;
        this.sync();
      }
      disconnectedCallback() {
        if (!this.abort) return;
        this.abort.abort();
        this.abort = null;
        this.observer?.disconnect();
        this.dialogObserver?.disconnect();
        this.stopRest();
        clearTimeout(this.watchdog);
        clearTimeout(this.loadDelay);
        if (this.idle != null && 'cancelIdleCallback' in window) cancelIdleCallback(this.idle);
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.load();
        this.removeAttribute('data-ready');
      }
    }
    customElements.define('ln-factory-film', LnFactoryFilm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ln-hero-reel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ln-hero-reel')) {
    class LnHeroReel extends HTMLElement {
      connectedCallback() {
        this.initializer = new MutationObserver(() => this.initialize());
        this.initializer.observe(this, { childList: true, subtree: true });
        this.initialize();
      }

      initialize() {
        if (this.controller || !this.querySelector('[data-reel-next]')) return;
        this.initializer.disconnect();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.slides = Array.from(this.querySelectorAll('[data-reel-slide]'));
        if (!this.slides.length) return;
        this.stage = this.querySelector('.ln-reel__stage');
        this.toggle = this.querySelector('[data-reel-toggle]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.motion.matches;
        this.inViewport = true;
        this.pointerIds = new Set();
        this.keyHeld = false;
        this.imageMs = Number(this.dataset.imageMs) || 2000;
        this.index = 0;
        this.playGeneration = 0;
        this.querySelector('.ln-reel__bar').hidden = this.slides.length < 2;
        this.stage.addEventListener('pointerdown', (event) => {
          if (event.button !== 0) return;
          this.pointerIds.add(event.pointerId);
          this.stage.setPointerCapture(event.pointerId);
          this.sync();
        }, options);
        const release = (event) => {
          this.pointerIds.delete(event.pointerId);
          this.sync();
        };
        this.stage.addEventListener('pointerup', release, options);
        this.stage.addEventListener('pointercancel', release, options);
        this.stage.addEventListener('lostpointercapture', release, options);
        this.stage.addEventListener('contextmenu', (event) => event.preventDefault(), options);
        this.stage.addEventListener('dragstart', (event) => event.preventDefault(), options);
        this.stage.addEventListener('keydown', (event) => {
          if (event.code === 'Space') {
            event.preventDefault();
            this.keyHeld = true;
            this.sync();
          }
          if (event.code === 'ArrowRight') { event.preventDefault(); this.show(this.index + 1); }
          if (event.code === 'ArrowLeft') { event.preventDefault(); this.show(this.index - 1); }
        }, options);
        this.stage.addEventListener('keyup', (event) => {
          if (event.code !== 'Space') return;
          event.preventDefault();
          this.keyHeld = false;
          this.sync();
        }, options);
        const releaseAll = () => {
          this.pointerIds.clear();
          this.keyHeld = false;
          this.sync();
        };
        this.stage.addEventListener('blur', () => { this.keyHeld = false; this.sync(); }, options);
        window.addEventListener('blur', releaseAll, options);
        document.addEventListener('visibilitychange', releaseAll, options);
        this.motion.addEventListener('change', (event) => { this.userPaused = event.matches; this.sync(); }, options);
        this.querySelector('[data-reel-prev]').addEventListener('click', () => this.show(this.index - 1), options);
        this.querySelector('[data-reel-next]').addEventListener('click', () => this.show(this.index + 1), options);
        this.toggle.addEventListener('click', () => { this.userPaused = !this.userPaused; this.sync(); }, options);
        this.slides.forEach((slide) => {
          const video = slide.querySelector('video');
          if (!video) return;
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.addEventListener('volumechange', () => { if (!video.muted) video.muted = true; }, options);
          video.addEventListener('ended', () => {
            if (this.activeVideo() === video && !this.isPaused()) this.show(this.index + 1);
          }, options);
          video.addEventListener('playing', () => {
            if (this.activeVideo() !== video || this.isPaused()) { video.pause(); return; }
            this.clearWatchdog();
          }, options);
          video.addEventListener('waiting', () => {
            if (this.activeVideo() === video && !this.isPaused()) this.armWatchdog();
          }, options);
          video.addEventListener('error', () => {
            if (this.activeVideo() === video && !this.isPaused()) this.startTimer(this.imageMs);
          }, options);
        });
        this.observer = new IntersectionObserver((entries) => {
          this.inViewport = entries[0].isIntersecting;
          this.sync();
        }, { threshold: 0 });
        this.observer.observe(this);
        this.show(0);
      }

      activeVideo() { return this.slides[this.index]?.querySelector('video'); }
      isPaused() { return this.userPaused || this.pointerIds.size > 0 || this.keyHeld || document.hidden || !this.inViewport; }

      stopTimer() {
        if (this.timer != null) {
          this.remaining = Math.max(0, this.deadline - performance.now());
          clearTimeout(this.timer);
          this.timer = null;
        }
      }

      startTimer(duration = this.remaining) {
        if (this.timer != null || this.isPaused() || this.slides.length < 2) return;
        this.remaining = duration;
        this.deadline = performance.now() + duration;
        this.timer = setTimeout(() => { this.timer = null; this.show(this.index + 1); }, duration);
      }

      clearWatchdog() { clearTimeout(this.watchdog); this.watchdog = null; }
      armWatchdog() {
        this.clearWatchdog();
        this.watchdog = setTimeout(() => { if (!this.isPaused()) this.show(this.index + 1); }, 6000);
      }

      show(index) {
        this.stopTimer();
        this.clearWatchdog();
        this.playGeneration += 1;
        this.slides.forEach((slide) => {
          const video = slide.querySelector('video');
          if (video) { video.pause(); video.currentTime = 0; }
          slide.hidden = true;
        });
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides[this.index].hidden = false;
        this.remaining = this.imageMs;
        this.querySelector('[data-reel-count]').textContent = String(this.index + 1);
        const next = this.slides[(this.index + 1) % this.slides.length];
        const nextImage = next.querySelector('img');
        if (nextImage) nextImage.loading = 'eager';
        const nextVideo = next.querySelector('video');
        if (nextVideo && nextVideo.preload === 'none') { nextVideo.preload = 'auto'; nextVideo.load(); }
        this.sync();
      }

      sync() {
        if (!this.slides?.length) return;
        const paused = this.isPaused();
        const held = this.pointerIds.size > 0 || this.keyHeld;
        this.toggleAttribute('data-held', held);
        this.toggleAttribute('data-paused', paused);
        this.toggle.setAttribute('aria-label', this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.toggle.setAttribute('aria-pressed', String(this.userPaused));
        this.querySelector('[data-reel-pause-icon]').hidden = this.userPaused;
        this.querySelector('[data-reel-play-icon]').hidden = !this.userPaused;
        const video = this.activeVideo();
        if (paused) {
          this.playGeneration += 1;
          this.stopTimer();
          this.clearWatchdog();
          if (video) video.pause();
          return;
        }
        if (!video) { this.startTimer(); return; }
        if (video.ended) { this.show(this.index + 1); return; }
        if (!video.paused) return;
        this.stopTimer();
        this.armWatchdog();
        const generation = ++this.playGeneration;
        video.muted = true;
        video.play().catch(() => {
          if (generation !== this.playGeneration || this.isPaused() || this.activeVideo() !== video) return;
          this.clearWatchdog();
          this.startTimer(this.remaining);
        });
      }

      disconnectedCallback() {
        this.initializer?.disconnect();
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.playGeneration += 1;
        this.stopTimer();
        this.clearWatchdog();
        this.slides?.forEach((slide) => slide.querySelector('video')?.pause());
      }
    }
    customElements.define('ln-hero-reel', LnHeroReel);
  }
  } catch(e) { console.error(e); }
})();

})();
